import { gql, useQuery } from '@apollo/client';
import { FullProviderUserInfo } from '../../../domain/types';

type ProviderUserByIdQueryInput = {
    oktaId: string;
};
type ProviderUserByIdQueryResult = {
    providerUser: FullProviderUserInfo,
};

export const PROVIDER_USER_BY_ID_QUERY = gql`
query queryProviderUserToEdit($oktaId: String!) {
  providerUser(
    oktaId: $oktaId
  ) {
    oktaId
    username
    email
    firstName
    lastName
    providerGuid
    providerCode
    providerName
    status
    clientPlacementAccess
    clientReportAccess
    providerMetricsAccess
    rosterAccess
    auditLogAccess
    contactEditAccess
    contactReadAccess
    userManagementAdminAccess
    bhpnAdmin
  }
}
`;
export const useProviderUserByIdQuery = (oktaId: string, noCache = false) => {
    const { data, loading, error } = useQuery<ProviderUserByIdQueryResult, ProviderUserByIdQueryInput>(PROVIDER_USER_BY_ID_QUERY, {
        variables: {
            oktaId,
        },
        ...(noCache ? { fetchPolicy: 'no-cache' } : {})
    });
    return {
        data, loading, error,
    };
};
